import { render, staticRenderFns } from "./OutboxVoices.vue?vue&type=template&id=566e775c&"
import script from "./OutboxVoices.vue?vue&type=script&lang=js&"
export * from "./OutboxVoices.vue?vue&type=script&lang=js&"
import style0 from "./OutboxVoices.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports